
import React, { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      "name": "TOUAREG GLOBAL",
      "description": "アジアを拠点とするプロフェッショナルな投資・資産管理サービス会社",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "serviceType": ["投資サービス", "資産管理", "プライベートエクイティ", "ファイナンシャルプランニング"],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "寺田北山田26-7-401",
        "addressLocality": "城陽市",
        "addressRegion": "京都府",
        "postalCode": "610-0121",
        "addressCountry": "JP"
      },
      "telephone": "090-3677-1000",
      "email": "touaregglobal@gmail.com",
      "areaServed": {
        "@type": "Place",
        "name": "アジア"
      },
      "founder": {
        "@type": "Person",
        "name": "福井秀延"
      },
      "sameAs": [
        `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <PortfolioSection />
        <TeamSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
